import { useCallback, useMemo, useState } from 'react'
import MedicalCertificateModal from './MedicalCertificateModal'
import { MedicalCertificateContext } from './MedicalCertificateContext'

/**
 * Mounts a single MedicalCertificateModal for the page and exposes openCreate/openView. Patient
 * context (from a booked slot) is optional — without it the modal starts with a patient picker.
 */
export default function MedicalCertificateProvider({ clinicId, clinicBrandId, clinicName, children }) {
  const [state, setState] = useState({ open: false, mode: 'create', patientContext: null })

  const openCreate = useCallback(
    (patientContext = null) => setState({ open: true, mode: 'create', patientContext }),
    [],
  )
  const openView = useCallback(
    (patientContext = null) => setState({ open: true, mode: 'view', patientContext }),
    [],
  )
  const close = useCallback(() => setState((s) => ({ ...s, open: false })), [])

  const value = useMemo(() => ({ openCreate, openView, close }), [openCreate, openView, close])

  return (
    <MedicalCertificateContext.Provider value={value}>
      {children}
      <MedicalCertificateModal
        open={state.open}
        mode={state.mode}
        patientContext={state.patientContext}
        clinicId={clinicId}
        clinicBrandId={clinicBrandId}
        clinicName={clinicName}
        onClose={close}
      />
    </MedicalCertificateContext.Provider>
  )
}
